





























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { AccountTeam, Team } from '@/models'
import { Utils } from '@/utils'
import ApiClient from '@/services/api-client'

@Component({
  components: {}
})
export default class AccountTeams extends Vue {
  @Prop({ required: true }) teams!: AccountTeam[]
  @Prop({ required: true }) currentAccountId!: string

  private selectedTeamIds: number[] = []
  private allTeams: Team[] = []
  private addingTeam = false
  private searchFilter = ''
  private teamsCurrentPage = 1
  private teamsPerPage = 10

  private teamsFields = [
    {
      key: 'name',
      label: this.$t('account_detail.teams.columns.name'),
      sortable: true
    },
    {
      key: 'responsibleId',
      label: this.$t('account_detail.teams.columns.responsible'),
      sortable: true
    },
    {
      key: 'createdOn',
      label: this.$t('account_detail.teams.columns.created_on'),
      sortable: true
    },
    {
      key: 'actions',
      label: this.$t('table.actions'),
      sortable: false,
      class: 'text-center'
    }
  ]

  get hasSearchFilter(): boolean {
    return this.searchFilter.trim() !== ''
  }

  get assignedTeamIds(): number[] {
    return this.teams.map(t => t.teamId)
  }

  get availableTeams(): Team[] {
    return this.allTeams.filter(t => !this.assignedTeamIds.includes(t.id))
  }

  get filteredTeams(): AccountTeam[] {
    if (!this.hasSearchFilter) return this.teams
    const filterNormalized = Utils.normalizeText(this.searchFilter)
    return this.teams.filter(at => {
      const nameNormalized = Utils.normalizeText(this.getTeamName(at.teamId))
      return nameNormalized.includes(filterNormalized)
    })
  }

  get teamsPaginated(): AccountTeam[] {
    const start = (this.teamsCurrentPage - 1) * this.teamsPerPage
    const end = start + this.teamsPerPage
    return this.filteredTeams.slice(start, end)
  }

  @Watch('searchFilter')
  onSearchFilterChange() {
    this.teamsCurrentPage = 1
  }

  async created() {
    await this.loadAllTeams()
  }

  async loadAllTeams() {
    try {
      this.allTeams = await ApiClient.getTeams()
    } catch (error) {
      console.error('Error loading teams:', error)
    }
  }

  getTeamName(teamId: number): string {
    const team = this.allTeams.find(t => t.id === teamId)
    return team ? team.name : `#${teamId}`
  }

  getTeamResponsible(teamId: number): string {
    const team = this.allTeams.find(t => t.id === teamId)
    return team ? team.responsibleId : '-'
  }

  handleAddTeams() {
    this.$emit('add-teams', {
      selectedTeamIds: this.selectedTeamIds,
      setAdding: (value: boolean) => { this.addingTeam = value },
      clearSelection: () => { this.selectedTeamIds = [] }
    })
  }

  handleDeleteTeam(accountTeam: AccountTeam) {
    this.$emit('delete-team', accountTeam)
  }

  handleDeleteAllTeams() {
    this.$emit('delete-all-teams')
  }

  public async refreshAllTeams() {
    await this.loadAllTeams()
  }
}
